import { render, staticRenderFns } from "./vodCard.vue?vue&type=template&id=27da7220&scoped=true&"
import script from "./vodCard.vue?vue&type=script&lang=js&"
export * from "./vodCard.vue?vue&type=script&lang=js&"
import style0 from "./vodCard.vue?vue&type=style&index=0&id=27da7220&scoped=true&lang=css&"
import style1 from "./vodCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27da7220",
  null
  
)

export default component.exports